export default "__VITE_PUBLIC_ASSET__e845361d__"